export default "__VITE_ASSET__DvTVleVz__"